import { useMemo } from "react";

import { Pill, PILL_COLORS } from "components/ui/Pill";

import {
  BOOLEAN_COLORS,
  DISABLED_COLORS,
  ICON_MAP,
  ICON_OPTIONS,
  STATUS_PILL_COLORS,
} from "../utils/constants";
import { formatStatusLabel } from "../utils/formatStatusLabel";

export const useColumns = () => {
  return useMemo(
    () => [
      {
        id: "name",
        header: "Value",
        width: "minmax(min-content, 1fr)",
        render: (row) => row.name,
      },
      {
        id: "label",
        header: "Label",
        width: "150px",
        render: (row) => row.label || "-",
      },
      {
        id: "icon",
        header: "Icon",
        width: "130px",
        render: (row) => {
          const raw = row.icon || ICON_OPTIONS[0].value;
          const iconKey = raw
            .split("-")
            .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
            .join("");
          const IconComponent = ICON_MAP[iconKey];
          if (!IconComponent) return iconKey;
          return (
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <IconComponent size={18} />
              {iconKey}
            </span>
          );
        },
      },
      {
        id: "urgentReview",
        header: "Urgent Review",
        width: "130px",
        render: (row) => {
          const val = row.urgentReview ? "YES" : "NO";
          return <Pill {...BOOLEAN_COLORS[val]}>{row.urgentReview ? "Yes" : "No"}</Pill>;
        },
      },
      {
        id: "createWorkflow",
        header: "Create Workflow",
        width: "130px",
        render: (row) => {
          const val = row.createWorkflow ? "YES" : "NO";
          return <Pill {...BOOLEAN_COLORS[val]}>{row.createWorkflow ? "Yes" : "No"}</Pill>;
        },
      },
      {
        id: "defaultNewStatus",
        header: "Default Status",
        width: "130px",
        render: (row) => {
          const status = row.defaultNewStatus || "NEW";
          return (
            <Pill {...(STATUS_PILL_COLORS[status] || PILL_COLORS.docUnknown)}>
              {formatStatusLabel(status)}
            </Pill>
          );
        },
      },
      {
        id: "closeTaskOnReview",
        header: "Close Task on Review",
        width: "150px",
        render: (row) => {
          const val = row.closeTaskOnReview ? "YES" : "NO";
          return <Pill {...BOOLEAN_COLORS[val]}>{row.closeTaskOnReview ? "Yes" : "No"}</Pill>;
        },
      },
      {
        id: "disabled",
        header: "Status",
        width: "110px",
        render: (row) => {
          const isDisabled = row.disabled;
          return (
            <Pill {...(isDisabled ? DISABLED_COLORS.DISABLED : DISABLED_COLORS.ENABLED)}>
              {isDisabled ? "Disabled" : "Enabled"}
            </Pill>
          );
        },
      },
    ],
    []
  );
};
